import { Component, Input } from '@angular/core';

import { Loggable } from 'app/utils/logging/loggable';

import { ScootaversePageService } from '../services/scootaverse-page.service';

@Component({
  selector: 'no-rooms-page',
  templateUrl: './no-rooms.component.html',
  styleUrls: ['./no-rooms.component.scss'],
  standalone: false,
})
export class NoRoomsPageComponent extends Loggable {
  @Input() public scootaverseId?: string;

  public constructor(private scootaversePageService: ScootaversePageService) {
    super();
    this.setDisplayName('NoRoomsPageComponent');
  }

  public async createRoom(): Promise<void> {
    await this.scootaversePageService.onCreateRoom(this.scootaverseId);
  }
}
